export default __webpack_public_path__ + "static/media/Foto16.0882bff5.png";